import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=b84dbfd0&scoped=true"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&id=b84dbfd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84dbfd0",
  null
  
)

export default component.exports